import { ActionTree } from 'vuex'
import { login, branchLogin, getUserInfo, quit } from '@/api/login'
import { getAccountAuths } from '@/api/account'
import util from '@/utils'
import auth from '@/utils/auth'

import { UserState } from '@/types/store/user'
import { RootState } from '@/types/store'
import { OForm } from '@/types/views/login'

export const actions: ActionTree<UserState, RootState> = {
  login({ commit, dispatch }, userInfo: OForm) {
    const token = util.createUniqueString()

    return new Promise(async (resolve, reject) => {
      try {
        let res: any = await login(userInfo)
        commit('SET_TOKEN', token)
        commit('SET_ID', res.id)
        commit('SET_NAME', res.realname)
        commit('SET_NICKNAME', res.accountname)
        commit('SET_AVATAR', '')
        commit('SET_PHONE', res.phone)
        commit('SET_STATUS', res.status)
        commit('SET_ROLES', [res.accounttype])
        commit('SET_ORGID', res.orgid)
        if (res.realname === '管理员') commit('SET_ADMIN', true)
        auth.setToken(token)
        dispatch('getUserAuths')
        resolve()
      } catch (err) {
        reject(err)
      }
    })
  },
  branchLogin({ commit, dispatch }, userInfo: OForm) {
    const token = util.createUniqueString()

    return new Promise(async (resolve, reject) => {
      try {
        let res = await branchLogin(userInfo)
        commit('SET_TOKEN', token)
        commit('SET_ID', res.id)
        commit('SET_NAME', res.realname)
        commit('SET_NICKNAME', res.accountname)
        commit('SET_AVATAR', '')
        commit('SET_PHONE', res.phone)
        commit('SET_STATUS', res.status)
        commit('SET_ROLES', [res.accounttype])
        commit('SET_ORGID', res.orgid)
        if (res.realname === '管理员') commit('SET_ADMIN', true)
        auth.setToken(token)
        dispatch('getUserAuths')
        resolve()
      } catch (err) {
        reject(err)
      }
    })
  },
  getUserInfo({ commit, state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        let res: any = await getUserInfo()
        commit('SET_TOKEN', auth.getToken())
        commit('SET_ID', res.id)
        commit('SET_NAME', res.realname)
        commit('SET_NICKNAME', res.accountname)
        commit('SET_AVATAR', '')
        commit('SET_PHONE', res.phone)
        commit('SET_STATUS', res.status)
        commit('SET_ROLES', [res.accounttype])
        commit('SET_USERINFO', res)
        commit('SET_ORGID', res.orgid)
        if (res.realname === '管理员') commit('SET_ADMIN', true)
        dispatch('getUserAuths')
        resolve()
      } catch (err) {
        reject(err)
      }
    })
  },
  getUserAuths({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        let auths = await getAccountAuths()
        commit('SET_USERAUTHS', (Array.isArray(auths) && auths.slice()) || [])
        resolve()
      } catch (err) {
        commit('SET_USERAUTHS', [])
        reject(err)
      }
    })
  },
  quit({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        await quit()
        auth.removeToken()
        commit('SET_ID', -1)
        commit('SET_NAME', '')
        commit('SET_NICKNAME', '')
        commit('SET_AVATAR', '')
        commit('SET_PHONE', '')
        commit('SET_STATUS', '')
        commit('SET_ROLES', [])
        commit('SET_USERINFO', {})
        resolve()
      } catch (err) {
        reject(err)
      }
    })
  }
}
